import Swal from "sweetalert2";
import { showSwal } from "./swal";           // Adjust path as needed


export const handleApiError = async (status, retryCallback,tryRefresh) => {
    switch (status) {
        case 401:
            await Swal.fire({
                icon: "warning",
                title: "Unauthorized",
                text: "Session expired. Please refresh token.",
                confirmButtonText: "Refresh Token",
                allowOutsideClick: false,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await tryRefresh(false);
                    await retryCallback();
                }
            });
            break;

        case 403:
            showSwal("warning", "Forbidden", "You don't have permission to perform this action.");
            break;

        case 500:
            showSwal("error", "Server Error", "An internal error occurred. Please try again later.");
            break;

        default:
            showSwal("error", "Error", "An unknown error occurred. Please try again.");
    }
};
